import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	useAjax,
	XhrStatus,
	TranslatedString
} from '@bosch/bt-ui';

import './HomePage.css';
import withErrorHandler from '../components/ErrorHandler';

const HomePage = (props) => {
	const {
		token
    } = props

	return (
		<div id="home-page">
			<h2 className="font-large">
				<TranslatedString stringId="home-description" />
			</h2>
			{
				token.token ?
					<h1 className="font-large">Session Expire On : {new Date(token.exp * 1000).toLocaleString('en-US', { hour12: false })}</h1>
				:
					<h1 className="font-large">
						Please login first!!!
					</h1>
			}
		</div>
	);
};

export default withErrorHandler(React.memo(HomePage));